import httpManager from "@/app/shared/utils/httpManager";
import { toFormData } from "@/app/shared/utils/helpers";

/**
 * @param {Object} body
 * @param {string} url
 * @returns {Promise<{ file: string, name: string }>} Url data
 */
export async function updateTablePreferences(scope, body) {
  const url = `/users/table-preferences/update-columns/`;
  const response = await httpManager.put(url, { columns: body, scope });

  return response?.data;
}